import EndingCustomExpectations from './EndingCustomExpectations';

export default EndingCustomExpectations;
